module.exports = __webpack_public_path__ + "img/almost-done.de9b5634.svg";